require('../scss/index.scss');

import $ from 'jquery';
import SignaturePad from 'signature_pad';

$('#menuButton').click(function (e) {
	$(this).toggleClass('active');
	$('.site-header__menu').toggleClass('active');

	$('main .container').toggleClass('active1');
	$('footer .container').toggleClass('active1');
	console.log('ok');
});

const canvas = document.querySelector('.signature-pad canvas');

if (canvas) {
	const signaturePad = new SignaturePad(canvas, {
		backgroundColor: 'rgb(255, 255, 255)'
	});

	console.log(canvas);

	function resizeCanvas() {
		var ratio =  Math.max(window.devicePixelRatio || 1, 1);
	
		canvas.width = canvas.offsetWidth * ratio;
		canvas.height = canvas.offsetHeight * ratio;
		canvas.getContext("2d").scale(ratio, ratio);

		signaturePad.clear();
	}

	window.onresize = resizeCanvas;
	resizeCanvas();

	const btn = $('.signature-pad__btn');

	btn.click(function (e) {
		console.log(canvas.width);
		console.log(canvas.height);
		$.ajax({
			type: "POST",
		  url: 'sendSignature.php',
		  data: {
				signature: signaturePad.toDataURL(),
				width: canvas.width,
				height: canvas.height
			},
		  success: function (data) {
				// console.log(data);
				if (data === 'ok') {
					alert('Message has been sent');
				} else {
					alert(data);
				}
		  },
		  error: function (data) {
				alert(data);
		  }
		});
	});
}



// WEBPACK FOOTER //
// ./src/js/index.js